export const engagementAppGroupIdCanvasStepBatchedStatsStepType =
  "/engagement/:app_group_id/canvas/step/batched_stats/:step_type";
